module.exports = __webpack_public_path__ + "img/reviews-star-userprofile.9e5136c9.svg";